<template>
    <modal @close="$emit('close')" :show-title="true" :size="'medium'">
        <div slot="header">
            <h5 class="modal-title">{{$t('gusti')}}</h5>
        </div>
        <div slot="body">
            <div class="w-100" v-for="group in this.groups">
                <div class="mt-3 mb-2">
                    <b>
                        <span class="s-titoletto text-uppercase">{{group.alias}}</span>:
                    </b>
                    <br>
                </div>
                <div class="d-flex justify-content-between" v-for="free_pick in group.processed_free_picks">
                    <div class="nome-scelte">
                        <div><b>{{free_pick.alias}}</b></div>
                        <div>{{free_pick.variazione_prezzo.toFixedGood(2)}} {{locale_currency}}</div>
                    </div>
                    <div class="quantita-scelte text-right">
                        <button class="btn btn-circle" @click="changeFreePick(free_pick)">
                            <i class="fas fa-sync"></i>
                        </button>
                    </div>
                </div>
            </div>
        </div>
    </modal>
</template>

<script>
    import {mapGetters, mapState} from 'vuex';

    import Modal from '../../partials/Modal';

    export default {
        name: "ModalChangeFreePick",
        components: {Modal},
        props: ['product', 'currentFreePicks', 'measureId', 'index'],
        computed: {
            groups: function () {
                let processed_groups = this.free_picks.gruppi;
                processed_groups.forEach((item) => {
                    item.processed_free_picks = [];
                });

                this.free_picks.ingredienti.forEach((ingredient) => {
                    if (ingredient.mask_locali_esclusi & this.locale.id) return;

                    const groupMeasure = this.free_picks.misure_gruppi.find((group) => {
                        return (group.id_misura_tipologia_prodotto === this.measureId && group.id_gruppo_aggiunte === ingredient.id_gruppo_aggiunte);
                    });

                    if (groupMeasure) {
                        //Cerco se esiste un'override del prezzo
                        const override = ingredient.misure_prezzi_override.find((obj) => {
                            return (obj.id_misura_tipologia_prodotto === this.measureId);
                        });

                        let add = Object.assign({}, ingredient, {
                            variazione_prezzo: (override ? override.prezzo : groupMeasure.variazione_prezzo),
                            variazione_prezzo_originale: groupMeasure.variazione_prezzo,
                            f_override: !!override
                        });

                        processed_groups.forEach((item_processed_group) => {
                            if (item_processed_group.id === add.id_gruppo_aggiunte) {
                                add.nome_gruppo_aggiunte = item_processed_group.nome;
                                item_processed_group.processed_free_picks.push(add);
                            }
                        });
                    }
                });

                //sort...
                processed_groups.sort((item1, item2) => {
                    if (item1.alias < item2.alias) {
                        return -1;
                    }

                    if (item1.alias > item2.alias) {
                        return 1;
                    }

                    return 0;
                });

                processed_groups.forEach((item, index) => {
                    item.processed_free_picks.sort((item1, item2) => {
                        if (item1.alias < item2.alias) {
                            return -1;
                        }

                        if (item1.alias > item2.alias) {
                            return 1;
                        }

                        return 0;
                    });
                });

                return processed_groups.filter((group) => {
                    return group.processed_free_picks.length;
                });
            },
            free_picks: function () {
                const free_pick = this.currentFreePicks[this.index];

                if (this.currentFreePicks.filter((current_pick) => current_pick && current_pick.id === free_pick.id).length === 1) {
                    return this.product.scelte_libere;
                }

                return Object.assign({}, this.product.scelte_libere, {
                    ingredienti: this.product.scelte_libere.ingredienti.filter((ingredient) => {
                        const current_tastes = this.currentFreePicks.filter((obj, indexObj) => obj && this.currentFreePicks.findIndex((obj2) => obj.id === obj2.id) === indexObj).map((obj) => obj.id);
                        if (this.product.max_gusti_scelte_libere && current_tastes.length >= this.product.max_gusti_scelte_libere) {
                            return current_tastes.includes(ingredient.id);
                        } else {
                            return true;
                        }
                    })
                });
            },
            ...mapState('restaurant', {
                locale: state => state.locale
            }),
            ...mapGetters('restaurant', {
                locale_currency: 'localeCurrency'
            })
        },
        methods: {
            changeFreePick: function (free_pick) {
                this.$emit('close', free_pick);
            }
        }
    }
</script>
